export const DEFAULT_QUERY_PARAMS = {
  IsPaginated: true,
  StartRow: 0,
  RowQty: 10,
  RequestStatusCode: '',
} as const;
